import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** shadcn/ui's class merger — every generated component imports this. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Scrolls an element into view once React has rendered it. Used when an Edit
 * button far down a list opens a form that sits above it, which on a phone
 * would otherwise open off-screen.
 */
export function revealSoon(id: string): void {
  setTimeout(() => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, 60);
}
